import script from "./QueryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryTable.vue?vue&type=script&setup=true&lang=js"

import "./QueryTable.vue?vue&type=style&index=0&id=4e49512d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e49512d"]])

export default __exports__